import api from '../api'
import analytics from '../utils/cdpAnalytics'

// http://plickers-api-documentation-pgjd3e8jb7.s3-website-us-east-1.amazonaws.com/#invite
export function inviteToPlickers(email) {
  return () => api.post('/invite', { email })
    .then((response) => {
      analytics.track('Invite to Plickers')
      return response
    })
    .catch((error) => error)
}
